import * as React from "react";
import { CarouselBlock } from "../../Pages/Ecommerce/Shared/CarouselBlock/CarouselBlock";
import { ImageCarouselItem } from "../KeyWorksCarousel/ImageCarouselItem/ImageCarouselItem";
import { PictureProfile } from "../../../ResizedImage/PictureProfile.csharp";

interface Picture {
    url: string;
    alt: string;
    responsiveData: {
        focalPoint: { x: number; y: number } | null;
        width: number;
        height: number;
    };
}

interface Item {
    picture: Picture;
    caption: string;
    copyright: string;
}

interface Model {
    title: string;
    items: Item[];
    theme: string;
    customThemeBackgroundColor?: string;
    customThemeFontColor?: string;
}

interface Translations {
    outOf: string;
    next: string;
    previous: string;
}

interface ImageCarouselProps {
    profile: PictureProfile;
    translations: Translations;
    model: Model;
}

export const ImageCarousel: React.FC<ImageCarouselProps> = (props: ImageCarouselProps) => {
    return (
        <div>
            <CarouselBlock
                title={props.model.title}
                theme={props.model.theme}
                customBgColor={props.model.theme === "custom" && props.model.customThemeBackgroundColor}
                customFontColor={props.model.theme === "custom" && props.model.customThemeFontColor}
                fullWidth
                previousSlideAriaLabel={props.translations.previous}
                nextSlideAriaLabel={props.translations.next}
                itemsPerSlideDesktop={2}
                itemsPerSlideMobile={2}
                displayData={props.model.items.map((item, index) => ({
                    key: item.picture.url + index,
                    data: <ImageCarouselItem {...item} profile={props.profile} />,
                }))}
                isExhibition={true}
            />
        </div>
    );
};
